<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <!-- <ng-container>
        <div style="padding: 15px; margin: 5px;max-width: 94%;">
            <div class="main-heading">
                <h1>Error DashBoard</h1>
            </div>
            <div>
                <a>Business Case</a><br>
                <a>IRR</a><br>
                <a>Sales and Volume</a>
            </div>
        </div>
    </ng-container> -->
    <ng-container>
        <div class="container">
            <div class="main-heading">
                <h1>Error DashBoard</h1>
            </div>
            <div class="links-container">
                <a routerLink="/businesscase" class="link-card">Business Case</a>
                <!-- <a routerLink="/irr" class="link-card">IRR</a>
                <a routerLink="/irr-npv" class="link-card">IRR NPV</a> -->
                <a routerLink="/newsalesandvolume" class="link-card">Sales and Volume</a>
                <a routerLink="/anticipated-date" class="link-card">Anticipated Market Formation Date</a>
                <a routerLink="/newcosting" class="link-card">Costing</a>
                <a routerLink="/costingchecker" class="link-card">Costing Comparision</a>
                <a routerLink="/all-rld" class="link-card">All RLD Zero Data</a>
                <a routerLink="/patents-expiration" class="link-card">Patents Expiration</a>
                <a routerLink="/litigation-events" class="link-card">Litigation Events</a>
                <!-- <a routerLink="/appeal-events" class="link-card">Appeal Events</a> -->
            </div>
        </div>
    </ng-container>

</div>